import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"

import whiteHeart from "../../images/kio-herz-weiss.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faArrowRight,
  faHandHoldingHeart,
} from "@fortawesome/pro-solid-svg-icons"

import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

const DonationBlock = ({ block }) => {
  return (
    <BlockWrapper block={block} showHeadline="false">
      <div className="flex flex-row flex-wrap -mx-grid">
        <div className="w-full text-center md:w-1/2 px-grid">
          <HeadlineEnhanced headline={block.headline} />
          <Richtext className="mt-8" text={block.text} />
          <div className="flex flex-row justify-center mt-4">
            <div className="text-left">
              <Image
                className="inline-block w-16 h-16 mr-4 rounded-full"
                image={block.author_image}
                aspectRatio="1by1"
              />
            </div>
            <div className="inline-block h-full my-auto text-left align-bottom">
              <span className="inline-block font-bold">{block.author}</span>
              <br />
              <span className="inline-block">{block.author_description}</span>
            </div>
          </div>
        </div>
        <div className="w-full mt-8 md:w-1/2 px-grid md:mt-0">
          <div className="relative lg:pl-[25%]">
            <Image
              className="hidden w-full lg:block"
              aspectRatio="3by2"
              image={block.image}
            />
            <div className="top-0 left-0 z-50 w-full h-full sm:w-1/2 md:w-3/4 lg:w-1/2 lg:absolute">
              <div className="flex flex-col w-full p-4 bg-white border border-gray-100 shadow-xl sm:mt-8 ">
                <Link
                  className="flex btn btn-red"
                  link="/hilfen/spenden-formular"
                >
                  Online spenden
                  <FontAwesomeIcon
                    icon={faHandHoldingHeart}
                    size="1x"
                    className="h-5 pt-0.5 ml-auto "
                  />
                </Link>
                <Link
                  className="flex mt-4 btn btn-primary"
                  link="/hilfen/spenden#ueberweisung"
                >
                  Überweisung
                  <Image
                    className="inline-block h-5 pt-1 ml-auto"
                    image={{ filename: whiteHeart, alt: "KiO hilft" }}
                  />
                </Link>
                <Link
                  className="flex mt-4 btn btn-secondary"
                  link="/hilfen/spenden#mehr-moeglichkeiten"
                >
                  Mehr Möglichkeiten
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    size="1x"
                    className="h-5 pt-0.5 ml-auto "
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default DonationBlock
